<template>
	<div class="containerMain">
		<title-bar :topTitle="true" topTitleText="Indicadores" class="mb-4"/>
		<title-bar v-if="school" :title="school.name" class="mb-4"/>
		<div class="col inner" v-if="synthesis" >
			<div style="width: 100%;">
				<div class="mb-4">
					<p v-if="synthesis.data.visit">
						<strong>{{`Visita ${synthesis.data.visit}`}}</strong>
						{{` del ${getHumanDateAndTime(synthesis.date)}`}}
					</p>
					<p v-else>{{`Realizado el ${getHumanDateAndTime(synthesis.date)}`}}</p>
				</div>

				<div class="mb-4" v-if="!school">
					<h2>Colegio</h2>
					<p>{{synthesis.school.name}}</p>
				</div>

				<div class="mb-4">
					<h2>Coach</h2>
					<p>{{getPersonFullName(synthesis.coach)}}</p>
				</div>
				<div class="mb-4">
					<h2>Head Coach</h2>
					<p v-if="synthesis.data.headCoach">{{synthesis.data.headCoach}}</p>
					<p v-else>Sin registro</p>
				</div>

				<div class="mb-4">
					<h2>Equipo Coaching</h2>
					<p v-if="synthesis.data.coachingTeam">{{synthesis.data.coachingTeam}}</p>
					<p v-else>Sin registro</p>
				</div>

				<div class="mb-4">
					<h2>Observaciones</h2>
					<p v-if="synthesis.data.observations">{{synthesis.data.observations}}</p>
					<p v-else>Sin registro</p>
				</div>

				<div class="mb-4">
					<h2>Evaluación</h2>
				</div>

				<b-alert variant="warning" show v-if="synthesis.data.evaluationsRisk > 0">
					<i class="fas fa-exclamation-circle"></i> Los cambios representan un riesgo
				</b-alert>

				<div class="table-responsive mb-4">
					<table class="table table-bordered table-hover">
						<thead class="thead-dark">
							<tr>
								<td class="table-bordeless"></td>
								<td class="text-center" colspan="2" v-for="level in synthesis.data.evaluations" :key="level.academicLevel">
									{{level.academicLevel}}
								</td>
								<td></td>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td class="table-borderless"></td>
								<template v-for="(level, index) in synthesis.data.evaluations">
								  <td class="text-center" v-for="language in level.languages" :key="`language-${language.language}-${index}`">
										{{language.language}}
									</td>
								</template>
								<td class="text-left">Total</td>
							</tr>
							<br>
							<tr>
								<td class="table-borderless">No. Docentes a evaluar</td>
								<template v-for="(level, index) in synthesis.data.evaluations">
									<td class="text-right" v-for="language in level.languages" :key="`plan-${language.language}-${index}`">
										{{language.plan}}
									</td>
								</template>
								<td class="text-right">{{totalPlannedAmount}}</td>
							</tr>
							<tr>
								<td>Ausente/Omisión</td>
								<template v-for="(level, index) in synthesis.data.evaluations">
									<td class="text-right" v-for="language in level.languages" :key="`absent-${language.language}-${index}`">
										{{language.absent}}
									</td>
								</template>
								<td class="text-right">{{totalAbsentAmount}}</td>
							</tr>
							<tr>
								<td>Cambio/Baja</td>
								<template v-for="(level, index) in synthesis.data.evaluations">
									<td class="text-right" v-for="language in level.languages" :key="`changed-${language.language}-${index}`">
										{{language.changed}}
									</td>
								</template>
								<td class="text-right">{{totalChangedAmount}}</td>
							</tr>
							<tr>
								<td>Nuevos 2019</td>
								<template v-for="(level, index) in synthesis.data.evaluations">
									<td class="text-right" v-for="language in level.languages" :key="`news-${language.language}-${index}`">
										{{language.news}}
									</td>
								</template>
								<td class="text-right">{{totalNewsAmount}}</td>
							</tr>
							<tr>
								<td>No observado ASC</td>
								<template v-for="(level, index) in synthesis.data.evaluations">
									<td class="text-right" v-for="language in level.languages" :key="`unobservable-${language.language}-${index}`">
										{{language.unobservable}}
									</td>
								</template>
								<td class="text-right">{{totalUnobservableAmount}}</td>
							</tr>
							<br>
							<tr>
								<td>Ausentismo</td>
								<template v-for="(level, index) in synthesis.data.evaluations">
									<td class="text-right"  v-for="language in level.languages" :key="`absenteeismPercentage-${language.language}-${index}`">
										{{language.absenteeismPercentage}}%
									</td>
								</template>
								<td class="text-right">{{totalAbsenteeismPercentage}}%</td>
							</tr>
							<tr>
								<td>Rotación</td>
								<template v-for="(level, index) in synthesis.data.evaluations">
									<td class="text-right"  v-for="language in level.languages" :key="`changePercentage-${language.language}-${index}`">
										{{language.changePercentage}}%
									</td>
								</template>
								<td class="text-right">{{totalChangePercentage}}%</td>
							</tr>
							<tr>
								<td>Nuevos 2019</td>
								<template v-for="(level, index) in synthesis.data.evaluations">
									<td class="text-right"  v-for="language in level.languages" :key="`newPercentage-${language.language}-${index}`">
										{{language.newPercentage}}%
									</td>
								</template>
								<td class="text-right">{{totalNewPercentage}}%</td>
							</tr>
							<br>
							<tr>
								<td>Efectividad ASC</td>
								<template v-for="(level, index) in synthesis.data.evaluations">
									<td class="text-right"  v-for="language in level.languages" :key="`effectivenessPercentage-${language.language}-${index}`">
										{{language.effectivenessPercentage}}%
									</td>
								</template>
								<td class="text-right">{{totalEffectivenessPercentage}}%</td>
							</tr>
						</tbody>
					</table>
				</div>

				<div class="mb-4">
					<h2>Rotación puestos clave</h2>
				</div>

				<b-alert variant="warning" show v-if="synthesis.data.keyPostionsRisk > 0">
					<i class="fas fa-exclamation-circle"></i> Los cambios representan un riesgo
				</b-alert>

				<div class="table-responsive mb-4">
					<table class="table table-bordered  table-hover">
						<thead class="thead-dark">
							<tr>
								<td></td>
								<td class="text-center" v-for="position in synthesis.data.keyPositions" :key="`title-${position.title}`">
									{{position.title}}
								</td>
								<td class="text-center">Total</td>
							</tr>
							<br>
						</thead>
						<tbody>
							<tr>
								<td>Plan</td>
								<td class="text-right" v-for="(position) in synthesis.data.keyPositions" :key="`plan-${position.title}`">
									{{position.plan}}
								</td>
								<td class="text-right">{{totalKeyPositionsPlannedAmount}}</td>
							</tr>
							<tr>
								<td>Reemplazo</td>
								<td class="text-right" v-for="(position) in synthesis.data.keyPositions" :key="`changed-${position.title}`">
									{{position.changed}}
								</td>
								<td class="text-right">{{totalKeyPositionsChangedAmount}}</td>
							</tr>
							<tr>
								<td>Vacante</td>
								<td class="text-right" v-for="(position) in synthesis.data.keyPositions" :key="`vacancies-${position.title}`">
									{{position.vacancies}}
								</td>
								<td class="text-right">{{totalKeyPositionsVacanciesAmount}}</td>
							</tr>
							<br>
							<tr>
								<td>% de Reemplazo</td>
								<td class="text-right" v-for="position in synthesis.data.keyPositions" :key="`changedPercentage-${position.title}`">
									{{position.changePercentage}}%
								</td>
								<td class="text-right">{{totalKeyPositionsChangePercentage}}%</td>
							</tr>
							<tr>
								<td>% de Vacante</td>
								<td class="text-right" v-for="position in synthesis.data.keyPositions" :key="`vacanciesPercentage-${position.title}`">
									{{position.vacanciesPercentage}}%
								</td>
								<td class="text-right">{{totalKeyPositionsVacanciesPercentage}}%</td>
							</tr>
						</tbody>
					</table>
				</div>

				<div class="mb-4">
					<h2>Plática para padres</h2>
					<p>
						Total de pláticas: <strong>{{synthesis.data.talkForParents.total}}</strong>
						Número de asistentes: <strong>{{synthesis.data.talkForParents.assistance}}</strong>
					</p>
				</div>

				<div class="mb-4">
					<h2>Curso Vespertino</h2>
					<p>
						Total de cursos: <strong>{{synthesis.data.talkForEveningCourse.total}}</strong>
						Número de asistentes: <strong>{{synthesis.data.talkForEveningCourse.assistance}}</strong>
					</p>
				</div>

				<div class="table-responsive mb-4">
					<table class="table table-bordered  table-hover">
						<thead class="thead-dark">
							<tr>
								<td class="text-center" colspan="2" v-for="level in synthesis.data.talkForEveningCourse.assistanceByLevel" :key="level.academicLevel">
									{{level.academicLevel}}
								</td>
							</tr>
						</thead>
						<tbody>
							<tr>
								<template v-for="(level, index) in synthesis.data.talkForEveningCourse.assistanceByLevel">
								  <td class="text-center" v-for="language in level.languages" :key="`language-${language.language}-${index}`">
										{{language.language}}
									</td>
								</template>
							</tr>
							<tr>
								<template v-for="(level, index) in synthesis.data.talkForEveningCourse.assistanceByLevel">
									<td class="text-right" v-for="language in level.languages" :key="`assistance-${language.language}-${index}`">
										{{language.assistance}}
									</td>
								</template>
							</tr>
						</tbody>
					</table>
				</div>

			</div>
		</div>
		<div class="col inner" v-else>
			<spinner :isMiniSpinner="true"/>
		</div>
	</div>
</template>

<script>
import helpers from '@/helpers';
import mediator from '@/mediator';

export default {
	props: ['synthesisId', 'schoolId'],
	mounted () {
		setTimeout(() => {
			mediator.showContent();
		}, 1000);
	},
	computed: {
		synthesis () {
			if (!this.$store.state.admin.synthesis) return null;
			let synthesis = this.$store.state.admin.synthesis;
			let type = typeof synthesis.data;
			if (type !== 'object') synthesis.data = JSON.parse(synthesis.data);
			synthesis.data.evaluations = synthesis.data.evaluations.map((level) => {
				level.languages = level.languages.map((language, index) => {
					language.absenteeismPercentage = this.getDifferencePercentage(level, index, 'absent');
					language.changePercentage = this.getDifferencePercentage(level, index, 'changed');
					language.newPercentage = this.getDifferencePercentage(level, index, 'news');
					language.effectivenessPercentage = this.getEffectivenessPercentage(level, index);
					return language;
				});
				return level;
			});
			synthesis.data.keyPositions = synthesis.data.keyPositions.map((position, index) => {
				position.changePercentage = this.getKeyPositionsDifferencePercentage(position, 'changed');
				position.vacanciesPercentage = this.getKeyPositionsDifferencePercentage(position, 'vacancies');
				return position;
			});
			synthesis.data.talkForParents = synthesis.data.formations.find((formation) => (formation.type == 'workshop'));
			synthesis.data.talkForEveningCourse = synthesis.data.formations.find((formation) => (formation.type == 'training'));
			return synthesis;
		},
		totalPlannedAmount () {
			return this.getEvaluationIndicatorsTotalAmount('plan');
		},
		totalAbsentAmount () {
			return this.getEvaluationIndicatorsTotalAmount('absent');
		},
		totalChangedAmount () {
			return this.getEvaluationIndicatorsTotalAmount('changed');
		},
		totalUnobservableAmount () {
			return this.getEvaluationIndicatorsTotalAmount('unobservable');
		},
		totalNewsAmount () {
			return this.getEvaluationIndicatorsTotalAmount('news');
		},
		totalAbsenteeismPercentage () {
			return this.getEvaluationIndicatorsTotalPercentage('absent', 'absenteeismPercentage');
		},
		totalChangePercentage () {
			return this.getEvaluationIndicatorsTotalPercentage('changed', 'changePercentage');
		},
		totalNewPercentage () {
			return this.getEvaluationIndicatorsTotalPercentage('news', 'newPercentage');
		},
		totalEffectivenessPercentage () {
			return this.getEvaluationIndicatorsTotalPercentage('effectivenessPercentage');
		},
		totalKeyPositionsPlannedAmount () {
			return this.getKeyPositionsTotalAmount('plan');
		},
		totalKeyPositionsChangedAmount () {
			return this.getKeyPositionsTotalAmount('changed');
		},
		totalKeyPositionsVacanciesAmount () {
			return this.getKeyPositionsTotalAmount('vacancies');
		},
		totalKeyPositionsChangePercentage () {
			return this.getKeyPositionsTotalPercentage('changed', 'changePercentage');
		},
		totalKeyPositionsVacanciesPercentage () {
			return this.getKeyPositionsTotalPercentage('vacancies', 'vacanciesPercentage');
		},
		school () {
			if (!this.$store.state.admin.schools) return null;
			if (!this.schoolId) return null;
			return this.$store.state.admin.schools.find((school) => (school.schoolId == this.schoolId));
		}
	},
	methods: {
		getHumanDateAndTime (date) {
			return helpers.dateTime.getHumanDateAndTime(date);
		},
		getPersonFullName (person) {
			return helpers.persons.getPersonFullName(person);
		},
		getHumanDate (date) {
			return helpers.dateTime.getHumanDate(date);
		},
		getEvaluationIndicatorsTotalAmount (key) {
			try {
				let amount = this.synthesis.data.evaluations.map((item) => {
					return parseInt(item.languages[0][key]) + parseInt(item.languages[1][key]);
				}).reduce((a, b) => (a + b));
				if (isNaN(amount)) return '?';
				return amount <= 0 ? 0 : amount;
			} catch (error) {
				return 'ERROR';
			}
		},
		getEvaluationIndicatorsTotalPercentage (key) {
			try {
				let plannedAmount = this.getEvaluationIndicatorsTotalAmount('plan');
				let realAmount = this.getEvaluationIndicatorsTotalAmount(key);
				let percentage = (plannedAmount - (plannedAmount - realAmount)) / plannedAmount;
				if (key == 'effectivenessPercentage') {
					if (plannedAmount <= 0) return '100.0';
					let absentAmount = this.getEvaluationIndicatorsTotalAmount('absent');
					let unobservableAmount = this.getEvaluationIndicatorsTotalAmount('unobservable');
					percentage = (plannedAmount - absentAmount - unobservableAmount) / plannedAmount;
				}
				let result = percentage * 100;
				if (isNaN(result)) return 0;
				if (result == 'Infinity') return 0;
				return result > 0 ? result.toFixed(1) : 0;
			} catch (error) {
				return 'ERROR';
			}
		},
		getDifferencePercentage (level, language, key) {
			try {
				let plannedAmount = level.languages[language].plan == 0 ? 1 : level.languages[language].plan;
				let realAmount = level.languages[language][key];
				let percentage = (plannedAmount - (plannedAmount - realAmount)) / plannedAmount;
				let result = percentage * 100;
				if (isNaN(result)) return 0;
				if (result == 'Infinity') return 0;
				return result > 0 ? result.toFixed(1) : 0;
			} catch (error) {
				return 'ERROR';
			}
		},
		getEffectivenessPercentage (level, language) {
			try {
				if (level.languages[language].plan <= 0) return '100.0';
				let plannedAmount = level.languages[language].plan;
				let absentAmount = level.languages[language].absent;
				let unobservableAmount = level.languages[language].unobservable;
				let percentage = (plannedAmount - absentAmount - unobservableAmount) / plannedAmount;
				let result = percentage * 100;
				if (isNaN(result)) return 0;
				if (result == 'Infinity') return 0;
				return result > 0 ? result.toFixed(1) : 0;
			} catch (error) {
				return 'ERROR';
			}
		},
		getKeyPositionsDifferencePercentage (position, key) {
			try {
				let plannedAmount = position.plan;
				let changedAmount = position[key];
				let percentage = (plannedAmount - (plannedAmount - changedAmount)) / plannedAmount;
				let result = percentage * 100;
				if (isNaN(result)) return 0;
				if (result == 'Infinity') return 0;
				return result > 0 ? result.toFixed(1) : 0;
			} catch (error) {
				return 'ERROR';
			}
		},
		getKeyPositionsTotalAmount (key) {
			try {
				let amount = this.synthesis.data.keyPositions.map((item) => {
					return parseInt(item[key]);
				}).reduce((a, b) => (a + b));
				if (isNaN(amount)) return '?';
				return amount <= 0 ? 0 : amount;
			} catch (error) {
				return 'ERROR';
			}
		},
		getKeyPositionsTotalPercentage (key) {
			try {
				let plannedAmount = this.getKeyPositionsTotalAmount('plan');
				let realAmount = this.getKeyPositionsTotalAmount(key);
				let percentage = (plannedAmount - (plannedAmount - realAmount)) / plannedAmount;
				let result = percentage * 100;
				if (isNaN(result)) return 0;
				if (result == 'Infinity') return 0;
				return result > 0 ? result.toFixed(1) : 0;
			} catch (error) {
				return 'ERROR';
			}
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/routes/admin/IndicatorDetail.vue